<script setup lang="ts">
import type { StudentSearchFormValues } from './schema';

const props = defineProps<{
  partnerUuid: string;
}>();

const onSubmit = async (values: StudentSearchFormValues): Promise<void> => {
  await navigateTo({
    path: `/${props.partnerUuid}/students/search`,
    query: values.q ? { q: values.q } : {},
  });
};
</script>

<template>
  <div>
    <slot :on-submit="onSubmit" />
  </div>
</template>
